"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactComponentUtils = exports.truncateMiddle = exports.delayPromise = void 0;
const lodash_1 = __importDefault(require("lodash"));
function delayPromise(duration) {
    return new Promise(resolve => setTimeout(resolve, duration));
}
exports.delayPromise = delayPromise;
const truncateMiddle = function (fullStr, strLen, separator) {
    if (fullStr.length <= strLen)
        return fullStr;
    separator = separator || '...';
    const sepLen = separator.length, charsToShow = strLen - sepLen, frontChars = Math.ceil(charsToShow / 2), backChars = Math.floor(charsToShow / 2);
    return fullStr.substr(0, frontChars) +
        separator +
        fullStr.substr(fullStr.length - backChars);
};
exports.truncateMiddle = truncateMiddle;
exports.ReactComponentUtils = {
    getPropValue: (props, path) => {
        return lodash_1.default.get(props, path);
    },
    ifPropChanged: (prevProps, thisProps, path) => {
        const prevValue = exports.ReactComponentUtils.getPropValue(prevProps, path);
        const thisValue = exports.ReactComponentUtils.getPropValue(thisProps, path);
        if (!lodash_1.default.isEqual(prevValue, thisValue)) {
            return true;
        }
        return false;
    },
    changedProps: (prevProps, thisProps) => {
        return lodash_1.default.mapKeys(Object.keys(prevProps)
            .filter(key => {
            return !lodash_1.default.isEqual(prevProps[key], thisProps[key]);
        })
            .map(key => {
            // console.log(
            //     'changed property:',
            //     key,
            //     'from',
            //     thisProps[key],
            //     'to',
            //     prevProps[key]
            // );
            return { key, from: prevProps[key], to: thisProps[key] };
        }), "key");
    }
};
